module.exports = "<h2 mat-dialog-title>\n  <!--{{description}}-->\n</h2>\n<mat-dialog-content >\n<div class=\"servant-dialog-title\">\n  {{data.servantName}}\n</div>\n<div class=\"servant-dialog-description\">\n    {{data.description}}\n</div>\n\n</mat-dialog-content>\n\n<mat-dialog-actions>\n  <button class=\"confirmButtons\" mat-raised-button color=\"primary\" (click)=\"close()\">بستن</button>\n</mat-dialog-actions>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/component/servant-profile/dialog-servant-profile.template.html
// module id = 980
// module chunks = 3